const baseStyle = {
  background: `white`,
  borderRadius: `3xl`,
  padding: 8,
};

export const Card = {
  baseStyle,
};
